import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/checklists/$slug")({
  head: () => buildRouteHead("/es/checklists", { noIndex: true }),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/es/downloads/checklists/$slug",
      params: { slug: params.slug },
      replace: true,
    });
  },
});
